module.exports = __webpack_public_path__ + "static/foco-logo-942c48af54b345a897d5dbc012fa9648.png";